import { Routes, Route } from "react-router-dom";

import Login from '../pages/Login/Login.js';
import Skeleton from '../pages/Skeleton/Skeleton.js';
import Error404 from '../shared/pages/Error404/G2Cloud/G2Cloud.js';

function App() {
  return (
    <Routes>
      <Route path = "/" element = {<Login />} />
      <Route path = "/:jwt" element = {<Login />} />
      <Route path = "/soporte" element = {<Skeleton view = {1}/>} />
      <Route path = "/soporte/ticket/:ticketId" element = {<Skeleton view={2}/>} />
      <Route path = "/*" element = {<Error404 />} />
      <Route path = "*" element = {<Error404 />} />
    </Routes>
  );
}

export default App;